<template>
    <branch-office-picker :value="currentBranchOffice" only-scoped v-on:change="onOfficeSelect" v-on:loading="loading=true" v-on:loaded="onLoaded"/>
</template>
<script>
    import BranchOfficePicker from '@/components/providers/BranchOfficePicker'
    import {mapState, mapMutations} from 'vuex'
    export default{
        components: {BranchOfficePicker},
        data(){
            return {
                show: true,
                loading: false
            }
        },
        computed:{
                ...mapState(['currentProvider', 'currentBranchOffice'])
        },
        methods: {
                ...mapMutations(['setCurrentBranchOffice']),
            onLoaded(){
                this.loading=false
                this.$emit('loaded')
            },
            onOfficeSelect(branchOffice){
                this.setCurrentBranchOffice(branchOffice)
            }
        }
    }
</script>

<style scoped>
    .picker-wrapper{ }
</style>